<template>
  <b-card-code title="Daftar Karyawan">
    <b-row>
      <b-col md="4" class="mb-1">
        <b-form-input placeholder="Cari" v-on:keyup.enter="getData()" v-model="filter.username" />
      </b-col>
      <b-col class="mb-1 text-right">
        <FormUserEmployee
          :is-loading="isLoading"
          :edit-id="editId"
          :validations="validations"
          :create-item="createItem"
          :update-item="updateItem"
          :clean-up-form="cleanUpForm"
          :form-payload="formPayload"
          :branch="branch"
          :role="role"
          @payloadUserEmployee="getPayload($event)"
        />
      </b-col>
    </b-row>

    <ListUserEmployee
      :result="result"
      :is-loading="isLoading"
      :get-category-data="getData"
      :edit-item="editItem"
      :busy="isLoading"
      :delete-item="deleteItem"
      :detail-item="detailItem"
      :handle-page-change="handlePageChange"
    />
    <DetailUserEmployee :result="detail" @resetValue="resetPassword($event)" />
  </b-card-code>
</template>

<script>
import _ from "lodash";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BButton,
  BTable,
  BFormGroup,
  BPagination,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BSpinner,
  BRow,
  BCol,
} from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import Ripple from "vue-ripple-directive";

import ListUserEmployee from "@/components/UserEmployee/ListUserEmployee.vue";
import FormUserEmployee from "@/components/UserEmployee/FormUserEmployee.vue";
import DetailUserEmployee from "@/components/UserEmployee/DetailUserEmployee.vue";

export default {
  components: {
    BCardCode,
    BButton,
    BTable,
    BFormGroup,
    BPagination,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BSpinner,
    BRow,
    BCol,
    ListUserEmployee,
    FormUserEmployee,
    DetailUserEmployee,
  },
  directives: {
    Ripple,
  },
  watch: {
    // filter: {
    //   handler: _.debounce(function (value) {
    //     this.getData();
    //   }, 300),
    //   deep: true,
    // },
  },

  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      result: {},
      isLoading: false,
      validations: {},
      formPayload: Object,
      editId: null,
      detail: {},
      filter: {
        keyword: "",
        username: ""
      },
      imageUserEmployee: null,
      role: Array,
      branch: Array,
    };
  },
  created() {
    this.getData()
    this.getRoleData()
    this.getBranchData()
  },
  methods: {
    resetPassword(event) {
      window.console.log(event);
    },
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    cleanUpForm() {
      this.editId = null;
      this.imageUserEmployee = null
      this.formPayload = {
        name: "",
        username: "",
        email: "",
        phoneNumber: "",
        roleId: "",
        isApproved: "",
        branchId: "",
        userId: "",
      };
      this.validations = "";
    },
    detailItem(item) {
      this.detail = item;
      this.$bvModal.show('form-detail-user-employee-modal')
    },
    createItem() {
      this.getPayload();
      const form = this.preparePayload();
      this.isLoading = true;

      this.$http
        .post("/user", form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            this.$bvModal.hide("form-user-employee-modal");
            this.getData();
            successNotification(this, "Success", "User karyawan berhasil di buat");
            this.cleanUpForm();
          }

          this.isLoading = false;
        })
        .catch((error) => {
          errorNotification(this, "Oops!", error.response.data.message);

          this.isLoading = false;
        });
    },
    updateItem() {
      const form = this.formPayload;
      this.isLoading = true;
      form.userId = this.editId

      this.$http
        .patch(`/user`, form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          this.$bvModal.hide("form-user-employee-modal");
          this.getData();
          successNotification(this, "Success", "User karyawan berhasil di ubah!");
          this.cleanUpForm();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.response)
          // if (error.response.data.meta.validations) {
          //   this.validations = error.response.data.meta.validations;
          //   errorNotification(this, "Oops!", error.response.data.meta.messages);
          // }
          this.isLoading = false;
        });
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          form.append(key, this.formPayload[key]);
        }
      }

      return form;
    },
    editItem(item) {
      this.cleanUpForm();
      this.editId = item.userId;
      this.imageUserEmployee = item.file;

      let roles = []

      for (let i = 0; i < item.roles.length; i++) {
        roles.push(item.roles[i]['roleId'])
      }

      this.formPayload = {
        name: item.name,
        username: item.username,
        email: item.email,
        phoneNumber: item.phoneNumber,
        roleId: item.roles ? roles : item.roles,
        isApproved: item.isApproved,
        branchId: item.branchId,
      };
      this.$bvModal.show("form-user-employee-modal");
    },
    deleteItem(id) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`/user/${id}`)
            .then((response) => {
              this.getData(this.currentPage);
              this.$swal({
                icon: "success",
                title: "Berhasil!",
                text: "User karyawan berhasil di hapus",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            })
            .catch((error) => {
              console.log("error");
              console.log(error);
            });
        }
      });
    },
    getData(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;

      this.$http
        .get("/user/page/non-admin", {
          params: queryParams,
        })
        .then((response) => {

          this.result = response.data.data;
          this.isLoading = false;
        });
    },
    getRoleData() {
      this.$http.get("role", {  }).then((response) => {
        let result = response.data.data;

        for (let i = 0; i < result.length; i++) {
          result[i].value = result[i].roleId;
          result[i].text = result[i].roleName;
          delete result[i].key;
          delete result[i].label;
        }



        this.role = result;
      });
    },
    getBranchData() {
      this.$http.get("/mastering/branch/findAll", { params: { size: 300 }  }).then((response) => {
        let result = response.data.data.content;

        for (let i = 0; i < result.length; i++) {
          result[i].value = result[i].branchId;
          result[i].text = result[i].branchName;
          delete result[i].key;
          delete result[i].label;
        }

        this.branch = result;
      });
    },
    handlePageChange(value) {
      this.getData(value)
    }
  },
};
</script>
